import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';
import ProbaWorkflowsSidebar from '@/components/probaworkflows_base_components/ProbaWorklfowsSidebar/ProbaWorkflowsSidebar.vue';
import { ASSIGN_POLICY_PERMISSION, GET_ALL_PERMISSIONS, GET_POLICY_PERMISSIONS, get_headers } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from 'axios';


export default {
  name: 'AssignedFeatures',
  components: { ProbaWorkflowsSidebar, NavigationBackButton },
  mixins: [alert_mixin],
  data: () => ({
    policy_id: null,
    permissions: [],
    assigned_permissions: [],
    expanded_feature_ids: new Set(),
    selected_sub_feature: null,
    selected_permissions: [],
    selected_sub_feature_map: {},
  }),
  mounted() {
    this.policy_id = sessionStorage.getItem('policy_id');
    this.headers = get_headers();
    this.get_all_permissions();
    this.get_policy_permissions();
  },
  methods: {
    get_all_permissions() {
      axios.get(GET_ALL_PERMISSIONS, { headers: this.headers })
        .then(response => {
          this.permissions = JSON.parse(response.data).data;
        })
        .catch(error => {
          this.show_error("Error fetching permissions:", error);
        });
    },
    get_policy_permissions() {
      const payload = { policy_id: this.policy_id };
      axios.post(GET_POLICY_PERMISSIONS, payload, { headers: this.headers })
        .then(response => {
          this.assigned_permissions = response.data.data;
          this.selected_permissions = this.assigned_permissions.map(pem => pem.sub_feature_crud_id);
        })
        .catch(error => {
          this.show_error("Error fetching assigned permissions:", error);
        });
    },
    handle_crud_selection(crud_id, is_checked) {
      if (is_checked) {
        if (!this.selected_permissions.includes(crud_id)) {
          this.selected_permissions.push(crud_id)
        }
      } else {
        const index = this.selected_permissions.indexOf(crud_id)
        if (index > -1) {
          this.selected_permissions.splice(index, 1)
        }
      }
    },
    is_crud_selected(crud_id) {
      return this.selected_permissions.includes(crud_id)
    },
    assign_permissions() {
      const payload = {
        policy_id: this.policy_id,
        permission_ids: this.selected_permissions
      };

      axios.post(ASSIGN_POLICY_PERMISSION, payload, {
        headers: this.headers,
      })
        .then(() => {
          this.show_success('Permission(s) assigned to policy successfully');
        })
        .catch((error) => {
          this.show_error('Error assigning permission(s): ' + error.message);
        });
    },
    toggle_feature(feature_id) {
      if (this.expanded_feature_ids.has(feature_id)) {
        this.expanded_feature_ids.delete(feature_id)
      } else {
        this.expanded_feature_ids.add(feature_id)
      }
    },
    is_feature_expanded(feature_id) {
      return this.expanded_feature_ids.has(feature_id)
    },
    handle_sub_feature_selection(main_feature_id, sub_feature_id) {
      const main_feature = this.permissions.find(f => f.id === main_feature_id)
      const sub_feature = main_feature?.sub_features.find(sf => sf.id === sub_feature_id)

      if (sub_feature) {
        const has_main_feature = Reflect.has(this.selected_sub_feature_map, main_feature_id);
        const selected_sub_feature = Reflect.get(this.selected_sub_feature_map, main_feature_id);
        if (has_main_feature && selected_sub_feature?.id === sub_feature_id) {
          Reflect.deleteProperty(this.selected_sub_feature_map, main_feature_id);
        } else {
          Reflect.set(this.selected_sub_feature_map, main_feature_id, sub_feature);
        }
      }
    },
    is_sub_feature_selected(main_feature_id, sub_feature_id) {
      const has_main_feature = Reflect.has(this.selected_sub_feature_map, main_feature_id);
      const selected_sub_feature = Reflect.get(this.selected_sub_feature_map, main_feature_id);

      return has_main_feature && selected_sub_feature?.id === sub_feature_id;
    },

    redirect_to_policies(){
      this.$router.push("/creating_a_policy");
    }
  }
}